<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="24">
          <el-form-item label="组织架构" prop="org_id">
              <el-cascader v-model="form_data.org_id" :options="org_node" :props="{ checkStrictly: true }" clearable>
              </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="培训项目" prop="site_id">
              <el-cascader v-model="form_data.site_id" :options="train_list" :props="{ checkStrictly: true }" clearable>
              </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item label="培训开始日期" prop="train_start_date">
                <el-date-picker v-model="form_data.train_start_date" type="date" autocomplete="off" clearable
                    placement="bottom-start"
                    value-format="yyyy-MM-dd" placeholder="请选择培训开始日期" />
            </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item label="培训结束日期" prop="train_end_date">
                <el-date-picker v-model="form_data.train_end_date" type="date" autocomplete="off" clearable
                    placement="bottom-start"
                    value-format="yyyy-MM-dd" placeholder="请选择培训结束日期" />
            </el-form-item>
        </el-col>


      </el-row>

    </el-form>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <l-auth-button type="primary" auth="cabinet_detail_add_btn" @click="handleSubmit" :loading="submitting">确 认</l-auth-button>
    </div>

  </div>

    

</template>

<script>
// import {
//   types
// } from './lavel.js';
// console.log(types)
export default {
  name: 'l-train-period-add',
  props: {
    train_id: {
      type: [String, Number],
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    // place_type: {
    //   type: [String, Number],
    //   default: null
    // },
    material_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
  },
  computed: {
    hasId() {
        console.log('MaterialAdd.Id:' + this.$props.id)
      return this.$props.id !== null;
    },
    // place_type_list() {
    //   return this.$store.state.list.place_type_list
    // }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    // "form_data.pid"() {
    //   if (!this.getdata_flag) {
    //     this.form_data.type = ""
    //   } else {
    //     this.getdata_flag = false
    //   }
    //   this.changes();
    // }
  },
  data() {
    return {
        data: [],
        count: 0,
      loading: false,//页面是否加载中
      getdata_flag: false,
      // LAVEL_LIST: types,
      //是否显示
      org_node: [

      ],
      train_list: [],
      photo_preview: '',
      //表单数据
      form_data: {
        // is_node: 0,
        // pid: "",
        // material_id: null,
        material_name: '',
        material_code: '',
        // department_level: '',
        abbreviation: '',
        // photo: '',
        // place_type: '',
        // is_public: 1,
      },
      nodeList: [],
      material_list: [],
      specification_list: [],
      //分类
      sel_type_id: "",
      type_name: "",
      //表单验证规则
      rules: {
        type_id: [
          { required: true, message: '器材分类不能为空', trigger: 'change' }
        ],  
        material_name: [
          { required: true, message: '器材名称不能为空', trigger: 'change' }
        ],
        material_quantity: [
          { required: true, message: '投放数量不能为空', trigger: 'change' }
        ],
        producted_at: [
          { required: true, message: '出厂日期不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // changes() {
    //   this.$_invoke("industry_getData", {
    //     type: this.form_data.type
    //   }).then((ret) => {  
    //     this.nodeList = ret.data
    //   })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },

    //获取数据
    getData() {
        this.loading = true;
//       this.$_invoke(`trainTemplate_saveData`, ).then((ret) => {
// console.log(ret);
//         this.tree_node = ret.tree_node;
//       }).finally(() => {
//         this.loading = false;
//       });
      if (!this.hasId) {
        
        this.$_invoke(`trainManage_getCabinetMaterialAdd`, { 
            id: this.$props.id,
            train_id: this.$props.train_id,
            }).then((ret) => {
            // this.data = ret.data;
            // this.count = ret.count;
          // this.form_data = ret.data;
          this.tree_node = ret.type_node;
          this.material_sku_list = ret.material_sku_list;
          
          this.getdata_flag = true;
          
          // this.data.forEach(element => {
          //     element["show"] = false;
          // })
          
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.$_invoke("trainManage_getTrainPeriodUpdate", {
            id: this.$props.id,
        })
        .then((ret) => {
        
            this.form_data = ret.data;
        
            this.org_node = ret.org_node;
            this.train_list = ret.train_list;
            
            this.getdata_flag = true;
        })
        .finally(() => {
            this.loading = false;
        });
        
      }

    },

    //上传培训视频成功后的回调
    handleUploadSuccess(res, field) {
        // console.log(field + this.photo_preview);
      this.form_data[field]=[res.data.photo];
      this[field + "_preview"] = res.data.photo;
      this.photo_preview = res.data.photo;
      console.log(this.photo_preview);
      // this.$_invoke("trainManage_videoUploadSave",{
      //   site_id:this.id,
      //   material_id:this.material_id,
      //   field:field,
      //   photo:[res.data.photo]
      // }).then(()=>{
      //     this.$_msg.success('上传成功');
      // })
    },
    
    changeMaterialType(typeid) {
        console.log(typeid);
        let sel_type_id = typeid
        if (typeof sel_type_id != "number") {
          const pid_len = sel_type_id.length;
          sel_type_id = sel_type_id[pid_len - 1];
        }
        
        this.loading = true;
        this.$_invoke(`trainManage_getMaterialListByTypeId`, {sel_type_id }).then((ret) => {
            this.material_list = ret.material_list;
        }).finally(() => {
          this.loading = false;
        });
    },
    
    changeMaterial(material_id) {
        console.log(material_id);
        let sel_material_id = material_id
        if (typeof sel_material_id != "number") {
          const pid_len = sel_material_id.length;
          sel_material_id = sel_material_id[pid_len - 1];
        }
        
        this.loading = true;
        this.$_invoke(`trainManage_getSpecificationIdByMaterial`, {sel_material_id }).then((ret) => {
            this.form_data.specification_id = ret.specification_id;
        }).finally(() => {
          this.loading = false;
        });
    },

    // changeSpecification(material_id,specificationid) {
    //     let sel_material_id = material_id
    //     let sel_specification_id = specificationid
    //     this.loading = true;
    //     this.$_invoke(`trainManage_getMaterialIdByMaterialNSpecification`, {sel_material_id,sel_specification_id })
    //         .then((ret) => {
    //             this.material_id = ret.material_id;
    //         })
    //         .finally(() => {
    //             this.loading = false;
    //         });
    // },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          // let form_data = Object.assign({}, this.form_data);
          // if (typeof form_data.pid != "number") {
          //   const pid_len = form_data.pid.length;
          //   form_data.pid = form_data.pid[pid_len - 1];
          // }
          this.submitting = true;
          // this.form_data.place_type = 3;
          if (!this.hasId) {//添加
            this.$_invoke('trainManage_saveMaterial', {
                material_id: this.material_id,
                train_id: this.$props.train_id,
                ...this.form_data}).then(() => {
              this.$_msg.success('添加培训分项成功');
              this.$emit('on-success');
              // this.getData();
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke('trainManage_updateTrainPeriod', {
                material_id: this.material_id,
                id: this.$props.id,
                ...this.form_data}).then(() => {
              this.$_msg.success('修改培训分项成功');
              this.$emit('on-success');
              // this.getData();
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`trainManage_deleteMaterialStock`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getData();
            }
          });
        })
        .catch(() => { });
    },
    
    //编辑/保存，改变状态
    // edit(row, mode) {
    //     console.log(row.show);
    //     if (mode == "edit") {
    //         row.show = true;
    //     } else {
    //         row.show = false;
    //     }

    //     //save
    //     if (mode == "save") {
    //         this.submitting = true;
    //         if (this.hasId) {
    //             this.$_invoke('trainManage_updateMaterial', {id: row.id, 
    //                                                             material_quantity: row.material_quantity, 
    //                                                             producted_at: row.producted_at})
    //                 .then(() => {
    //             this.$_msg.success('修改消防器材成功');
    //             this.getData();
    //           }).finally(() => {
    //             this.submitting = false;
    //           })
    //         }
    //     }
    // }
    
  },
}
</script>